import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import React from 'react';
import { IPartner } from '../../../../../types/partner';
import ListOfTeamMembers from './ListOfTeamMembers';
import ListPartnerPrograms from './ListPartnerPrograms';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </Box>
  );
}
function a11yProps(index: number, active: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
    sx: {
      color: index === active ? '#4785FF' : 'black',
    },
  };
}

interface IProps {
  partner: IPartner | null;
}

function ProgramTeamTab({ partner }: IProps) {
  const [value, setValue] = React.useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="Team and programs tab"
        >
          <Tab label="Programs" {...a11yProps(0, value)} />
          <Tab label="Team Memembers" {...a11yProps(1, value)} />
        </Tabs>
      </Box>
      <CustomTabPanel value={value} index={0}>
        <ListPartnerPrograms />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <ListOfTeamMembers partner={partner} />
      </CustomTabPanel>
    </Box>
  );
}

export default ProgramTeamTab;
